import { Injectable, OnDestroy } from '@angular/core';
import { WebApiClient } from 'src/app/services/web-api-client.service';
import { WebApiService } from 'src/app/services/web-api.service';
import { Dx, DxWithICD9 } from 'src/app/services/api-service/dx/dx';
import { Router } from '@angular/router';
import { RouteInfoService } from 'src/app/services/route-info.service';
import { PaymentMaster } from 'src/app/payments/models/payment-master';
import { SystemCode } from 'src/app/services/api-service/system-code/system-code';
import { ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { MultiPrescriptWrite } from 'src/app/shared/hcr-lib/MultiPrescriptWrite';
import { TreatmentData } from 'src/app/shared/hcr-lib/TreatmentData';
import { Rx } from 'src/app/services/api-service/rx/rx';
import { PageData2 } from 'src/app/shared/models/page-data';
import { WholeHist } from 'src/app/services/api-service/hist/whole-hist';
import { DxOpt, HistEditOption, RsOpt, RxOpt, userStat } from 'src/app/services/api-service/hist/hist-edit-option';
import { HistActionEnum } from 'src/app/enums/HistActionEnum';
import { VitalSign } from './vital-sign';
import { NhiRecord } from '../NHI/nhiRecord';
import { homecareRx } from './homecareRx';
import { Clinic } from 'src/app/system/clinic/models/clinic';
import { RecardListDto } from './recard-list';
import { isNullOrUndefined } from 'src/app/shared/utilities';
import { HistOrder } from 'src/app/hist/models/hist-order';
import { NHIRegIC } from '../register/nhiRegIc';
import { DrugBagInfo, ERxDataRequest, HistPrintDrugDto, ReceiptInfoDto, RepeatedPrescriptionDto, RepeatedPrescriptionQRcode, RepeatedPrescriptionRequest, WholeLargeHist } from './whole-large-hist';
import { PrescriptionSignMultiWrite } from 'src/app/shared/hcr-lib/PrescriptionSignMultiWrite';
import { PrescriptionFeedBack, PrescriptionSave } from 'src/app/hist/models/prescription-save';
import { CustomResult } from 'src/app/shared/models/custom-result';
import { ArrearReceiptViewModel } from 'src/app/system/report/components/arrear-receipt/arrear-receipt.component';
import { decreeRx } from './decreeRx';
import { VisitcountQueryDto, VisitcountReportData, VisitcountListData, VisitcountSumData } from 'src/app/hist/models/visitcount-report';
import { LabHRxListPageCollection, LabPrescriptionAndHrxListQuery, LabPrescriptionPageCollection } from './hist-api.model';
import { DateHelper } from 'src/app/shared/helpers/date-helper';
import { TCMFormula } from '../rx/TCMFormula';
import { DxVersionTag } from '../../data-service/clinic-data-service';
import { IRegNextPatientDto } from '../register/RegisterEditDto';
import { Referral } from '../referral/referral';
import { HistListItem } from 'src/app/hist/models/hist-list-item';
import { HealthInsurance } from 'src/app/shared/hcr-lib/HealthInsurance';
import { DailyReconReportQueryDto, DailyReconReportDto, DailyReconReportLackDto } from 'src/app/hist/models/daily-recon';
import { FeeSigningReceiptDto, FeeSigningReceiptQueryDto } from 'src/app/hist/models/fee-signing-receipt';
import { query } from '@angular/animations';
import { HistView } from 'src/app/hist/models/hist-view';
import { HistUserReportData, HistUserReportQueryDto } from 'src/app/hist/models/hist-user-report';
import { VPNGetRandomXandSignX } from 'src/app/shared/hcr-lib/VPNGetRandomXandSignX';
import { OrderModel } from 'src/app/hist/models/order-model';
import { OrderMedical } from 'src/app/card-reader/cnhi-eii-test/models/blue-tooth-export';
import { StringLiteral } from 'typescript';
import { SignalRConnectionIdService } from 'src/app/services/signalr-connection-id.service';


export class HistToICCardData {
  APartCode: string;
  MultiPrescriptWrite: MultiPrescriptWrite;
  PrescriptionSignMultiWrite: PrescriptionSignMultiWrite;
  TreatmentData: TreatmentData;
  HealthInsurance: HealthInsurance;
  RegicId: number;
  RegId: number;
  HistoryId?: number;
}

export interface ddiData {
  RtnCode: string;
  rtnCode: string;
  sub: ddiSubOne[];
}

export class ddiSubOne {
  oType: string;
  RtnNum: string;
  sub: ddiSubTwo[];

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      oType: '',
      RtnNum: '',
      sub: []
    } as ddiSubOne;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        if (key.toLocaleLowerCase() === 'sub') {
          this[toKeys[idx]] = [];
          for (let j = 0; j < data[key].length; j++) {
            this[toKeys[idx]].push(new ddiSubTwo(data[key][j]));
          }
        } else {
          this[toKeys[idx]] = data[key];
        }
      }
    }
  }
}

export class ddiSubTwo {
  oOrder: string;
  oMsg: string;
  CDrugName: string;
  ATC7Name: string;
  Effect: string;
  Mechanism: string;
  Management: string;
  sub: ddiSubThree[];

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      oOrder: '',
      oMsg: '',
      CDrugName: '',
      ATC7Name: '',
      Effect: '',
      Mechanism: '',
      Management: '',
      sub: []
    } as ddiSubTwo;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        if (key.toLocaleLowerCase() === 'sub') {
          this[toKeys[idx]] = [];
          for (let j = 0; j < data[key].length; j++) {
            this[toKeys[idx]].push(new ddiSubThree(data[key][j]));
          }
        } else {
          this[toKeys[idx]] = data[key];
        }
      }
    }
  }
}

export class ddiSubThree {
  HospName: string;
  FuncDT: string;
  DDIATC7Name: string;
  DDICDrugName: string;
  DDIOrder: string;
  HospSub: hospSubFour[];
  DDISub: ddiSubFour[];

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      HospName: '',
      FuncDT: '',
      DDIATC7Name: '',
      DDICDrugName: '',
      DDIOrder: '',
      HospSub: [],
      DDISub: []
    } as ddiSubThree;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        if (key.toLocaleLowerCase() === 'hospsub') {
          this[toKeys[idx]] = [];
          for (let j = 0; j < data[key].length; j++) {
            this[toKeys[idx]].push(new hospSubFour(data[key][j]));
          }
        } else if (key.toLocaleLowerCase() === 'ddisub') {
          this[toKeys[idx]] = [];
          for (let j = 0; j < data[key].length; j++) {
            this[toKeys[idx]].push(new ddiSubFour(data[key][j]));
          }
        } else {
          this[toKeys[idx]] = data[key];
        }
      }
    }
  }
}

export class hospSubFour {
  HospName: string;
  FuncDT: string;

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      HospName: '',
      FuncDT: ''
    } as hospSubFour;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        this[toKeys[idx]] = data[key];
      }
    }
  }
}

export class ddiSubFour {
  IngName: string;
  DDIIngName: string;
  Effect: string;
  Mechanism: string;
  Management: string;
  Alternatives: string;

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      IngName: '',
      DDIIngName: '',
      Effect: '',
      Mechanism: '',
      Management: '',
      Alternatives: ''
    } as ddiSubFour;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        this[toKeys[idx]] = data[key];
      }
    }
  }
}

export interface medPrtData {
  RtnCode: string;
  rtnCode: string;
  sub: medPrtSubOne[];
}

export class medPrtSubOne {
  oType: string;
  RtnNum: string;
  sub: medPrtSubTwo[];

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      oType: '',
      RtnNum: '',
      sub: []
    } as medPrtSubOne;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        if (key.toLocaleLowerCase() === 'sub') {
          this[toKeys[idx]] = [];
          for (let j = 0; j < data[key].length; j++) {
            this[toKeys[idx]].push(new medPrtSubTwo(data[key][j]));
          }
        } else {
          this[toKeys[idx]] = data[key];
        }
      }
    }
  }
}

export class medPrtSubTwo {
  oOrder: string;
  HRiskOrder: string;
  oMsg: string;
  ATC5EName: string;
  HRiskATCEName: string;
  DrugGroupCName: string;
  PresMedDay: string;
  EDate: string; // 民國年月日YYYMMDD
  OwnQty1: string;
  OwnQty2: string;
  ReasonableInterval: string;
  Interval: string;
  StandardType: string;
  sub: medPrtSubThree[];

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      oOrder: '',
      HRiskOrder: '',
      oMsg: '',
      ATC5EName: '',
      HRiskATCEName: '',
      DrugGroupCName: '',
      PresMedDay: '',
      EDate: '',
      OwnQty1: '',
      OwnQty2: '',
      ReasonableInterval: '',
      Interval: '',
      StandardType: '',
      sub: []
    } as medPrtSubTwo;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        if (key.toLocaleLowerCase() === 'sub') {
          this[toKeys[idx]] = [];
          for (let j = 0; j < data[key].length; j++) {
            this[toKeys[idx]].push(new medPrtSubThree(data[key][j]));
          }
        } else {
          this[toKeys[idx]] = data[key];
        }
      }
    }
  }
}

export class medPrtSubThree {
  NSAIDsType: string;
  HospName: string;
  FuncDT: string;
  Day: string;
  DrugGroupCName: string;
  OrderQty: string;
  StdQty: string;
  Std: string;
  OrderCName: string;
  RealInspectDate: string;
  CurePath: string;
  LftpOrder: string;
  LftpOrderName: string;
  PDTmode: string;

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      NSAIDsType: '',
      HospName: '',
      FuncDT: '',
      Day: '',
      DrugGroupCName: '',
      OrderQty: '',
      StdQty: '',
      Std: '',
      OrderCName: '',
      RealInspectDate: '',
      CurePath: '',
      LftpOrder: '',
      LftpOrderName: '',
      PDTmode: ''
    } as medPrtSubThree;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        this[toKeys[idx]] = data[key];
      }
    }
  }
}

export class allergyData {
  RtnCode: string;
  rtnCode: string;
  sub: allergySubOne[];
}

export class allergySubOne {
  oType: string;
  RtnNum: string;
  sub: allergySubTwo[];

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      oType: '',
      RtnNum: '',
      sub: []
    } as allergySubOne;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        if (key.toLocaleLowerCase() === 'sub') {
          this[toKeys[idx]] = [];
          for (let j = 0; j < data[key].length; j++) {
            this[toKeys[idx]].push(new allergySubTwo(data[key][j]));
          }
        } else {
          this[toKeys[idx]] = data[key];
        }
      }
    }
  }
}

export class allergySubTwo {
  allergyOrder_text: string;
  upload_Flag: string;
  hospName: string;
  upload_date: string;

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      allergyOrder_text: '',
      upload_Flag: '',
      hospName: '',
      upload_date: ''
    } as allergySubTwo;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        this[toKeys[idx]] = data[key];
      }
    }
  }
}

export class specialData {
  RtnCode: string;
  rtnCode: string;
  sub: specialSubOne[];
}

export class specialSubOne {
  oType: string;
  RtnNum: string;
  sub: specialSubTwo[];

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      oType: '',
      RtnNum: '',
      sub: []
    } as specialSubOne;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        if (key.toLocaleLowerCase() === 'sub') {
          this[toKeys[idx]] = [];
          for (let j = 0; j < data[key].length; j++) {
            this[toKeys[idx]].push(new specialSubTwo(data[key][j]));
          }
        } else {
          this[toKeys[idx]] = data[key];
        }
      }
    }
  }
}

export class specialSubTwo {
  DrugGroupCName: string;
  DrugGroupCode: string;
  Dose: string;
  SugDose: string;

  constructor(data: any = null) {
    if (!data) return;
    var fromKeys = Object.keys(data);
    var toKeys = Object.keys(this.emptyObject());
    this.cloneData(fromKeys, toKeys, data);
  }

  emptyObject() {
    return {
      DrugGroupCName: '',
      DrugGroupCode: '',
      Dose: '',
      SugDose: ''
    } as specialSubTwo;
  }

  cloneData(fromKeys: string[], toKeys: string[], data: any) {
    for (let i = 0; i < fromKeys.length; i++) {
      const key = fromKeys[i];
      const idx = toKeys.findIndex(x => x.toLowerCase() === key.toLowerCase());
      if (idx >= 0) {
        this[toKeys[idx]] = data[key];
      }
    }
  }
}

/** 雲端查詢1.0 */
export class nhiReq {
  /** 醫事機構代碼 */
  sHospId: string;
  /** 醫事人員身分證號 */
  sHcaId: string;
  /** 病人身分證號 */
  sPatId: string;
  sub: nhiReqSubOne[];
}

/** 雲端查詢2.0 + 控制軟體5.x */
export class nhiReqV2CSHIS5 extends nhiReq {
  /** 病人所持卡片類別 1：虛擬健保卡 2：實體健保卡 */
  sPatCardType: string;
  /** 醫事人員卡片編號 */
  sHcaCardId: string;
  /** 健保卡片編號 */
  sPatCardId: string;
  /** 亂數 */
  sClientRandom: string;
  /** 簽章 */
  sSignature: string;
  /** 雲端資料憑證 */
  vhcCloudToken: string;
  /** SAM 卡卡片編號 */
  sSamId: string;
  /** 病患出生日期 資料類別13：保險對象特定醫療資訊查詢為必填, 除此外非必填 */
  sPatBirthday: string;

  constructor(data: any = null) {
    super();
    if (!data) return;
    this.toModel(data);
  }

  toModel(data: nhiReqV2) {
    this.sHospId = data.sHospId;
    this.sHcaId = data.sHcaId;
    this.sPatId = data.sPatId;
    this.sub = data.sub;
    this.sPatCardType = data.sPatCardType;
    this.sHcaCardId = data.sHcaCardId;
    this.sPatCardId = data.sPatCardId;
    this.sClientRandom = data.sClientRandom;
    this.sSignature = data.sSignature;
    this.vhcCloudToken = data.vhcCloudToken;
    if (data.sPatBirthday) this.sPatBirthday = data.sPatBirthday;
    this.sSamId = data.sSamId;
  }
}

/** 控制軟體6.0 驗證資訊 */
export class verifyCSHIS6 {
  /** 簽章 */
  signature: string;
  /** 簽章亂數 */
  clientRandom: string;
  /** 安全模組編號 */
  samId: string;
  /** 醫事機構代碼 */
  hospitalId: string;
  /** 服務類別 */
  serviceType: string;
  /** 醫事人員卡片編號 */
  hpcId: string;
  /** 醫事人員身分證號 */
  hpcIdNo: string;
  /** 健保卡卡片編號 */
  hcId: string;
  /** 健保卡身分證號 */
  hcIdNo: string;
}

/** 雲端查詢2.0 + 控制軟體6.0 */
export class nhiReqV2CSHIS6 {
  /** 醫事機構代碼 */
  sHospId: string;
  /** 醫事人員身分證號 */
  sHpcId: string;
  /** 病人身分證號 */
  sPatId: string;
  /** 驗證資訊 */
  sVerify: verifyCSHIS6;
  /** 病患出生日期 資料類別13：保險對象特定醫療資訊查詢為必填, 除此外非必填 */
  sPatBirthday: string;
  sub: nhiReqSubOne[];

  constructor(data: any = null) {
    if (!data) return;
    this.toModel(data);
  }

  toModel(data: nhiReqV2) {
    this.sHospId = data.sHospId;
    this.sHpcId = data.sHpcId;
    this.sPatId = data.sPatId;
    this.sVerify = data.sVerify;
    if (data.sPatBirthday) this.sPatBirthday = data.sPatBirthday;
    this.sub = data.sub;
  }
}

/** 雲端查詢2.0 + 控制軟體5.x + 控制軟體6.0 = 全集合 */
export type nhiReqV2Set = nhiReqV2CSHIS5 & nhiReqV2CSHIS6;
export class nhiReqV2 implements nhiReqV2Set {
  // from nhiReq
  sHospId: string = '';
  sHcaId: string = '';
  sPatId: string = '';
  sub: nhiReqSubOne[] = [];

  // from nhiReqV2CSHIS5
  sPatCardType: string = '';
  sHcaCardId: string = '';
  sPatCardId: string = '';
  sClientRandom: string = '';
  sSignature: string = '';
  vhcCloudToken: string = '';
  sPatBirthday: string = '';
  sSamId: string = '';

  // from nhiReqV2CSHIS6
  sHpcId: string = '';
  sVerify: verifyCSHIS6 | null = null;

  toModel() {
  }

  toVerify(data: VPNGetRandomXandSignX) {
    this.sVerify = {
      signature: data.signature || '',
      clientRandom: data.clientRandom || '',
      samId: data.samId || '',
      hospitalId: data.hospitalId || '',
      serviceType: data.serviceType || '',
      hpcId: data.hpcId || '',
      hpcIdNo: data.hpcIdNo || '',
      hcId: data.hcId || '',
      hcIdNo: data.hcIdNo || ''
    };
  }
}

export type clinicRx = {
  Code: string;
  Name: string;
  EName: string;
}

export class nhiReqSubOne {
  /** 資料類別 */
  sType: string;
  sub: nhiReqSubTwo[];
}

export type StatOpts = { statDx: userStat, statRx: userStat, statCC: userStat, statPE: userStat }
export class nhiReqSubTwo {
  /** 醫令代碼 */
  sOrder: string;
}
export type HrxInitQuery =
  {
    codes: string[];
    types: number[];
    dateQuery: Date;
    cusTp: string;
    paySysA?: string;
    specialType?: string;
  }
export type HrxInitResult =
  {
    Rx: Rx;
    AlternativeRx: Rx;
    CommonSetting: homecareRx;
    Decree: decreeRx[] | null;
    IsApplyFree: boolean;
    LabBedsidetesting: boolean;
  }
export enum CheckResult {
  Success = 0,
  warning = 1,
  Error = 2
}
export enum CheckResultAction {
  None = 0,
  Alert = 1,
  InsertRx = 2,
  InsertDx = 3,
  SetCase = 4,
  SetSpec1 = 5,
  SetCusTot = 6,
  SetSameTreat = 7,
  SetChosenSur = 8,
  SetLockCase = 9,
  SetEmerAddtion = 31,
  SetMPLAN = 32,
  RemoveSpec1 = 995
}
export class HistCheckResult {
  Result: CheckResult;
  Action: CheckResultAction;
  Data: string;
}
export type GetWholeHistQuery =
  {
    regId: number;
  }

export class MedicationWayReportViewModel {
  /**
   *掛號證=病歷號
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  PatientNo: string;

  /**
   *病患姓名
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  PatientName: string;

  /**
 *病患身分證
 *
 * @type {string}
 * @memberof MedicationWayReportViewModel
 */
  PatientCId: string;

  /**
   *掛號身分
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  RegisterICode: string;

  /**
   *就診日=看診日期
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  RegisterDate: string;

  /**
   *看診號
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  RegisterWaitNo: string;

  /**
   *掛號卡序
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  RegisterIcno: string;

  /**
   *院所名稱
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  ClinicName: string;

  /**
   *醫師姓名
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  DoctorName: string;

  /**
   *藥師姓名
   *
   * @type {string}
   * @memberof MedicationWayReportViewModel
   */
  PharmacistName: string;

  /**
   *醫令列表
   *
   * @type {MedicationWayHRxesViewModel[]}
   * @memberof MedicationWayReportViewModel
   */
  HRxes: MedicationWayHRxesViewModel[];
}

export class MedicationWayHRxesViewModel {
  /**
   *院內藥材代碼
   *
   * @type {string}
   * @memberof MedicationWayHRxesViewModel
   */
  RxCode: string;
  /**
   *院內藥材名稱
   *
   * @type {string}
   * @memberof MedicationWayHRxesViewModel
   */
  RxName: string;
  /**
   *醫令頻率
   *
   * @type {string}
   * @memberof MedicationWayHRxesViewModel
   */
  Freq: string;
  /**
   *醫令途徑(服法)
   *
   * @type {string}
   * @memberof MedicationWayHRxesViewModel
   */
  Way: string;
  /**
   *次量
   *
   * @type {string}
   * @memberof MedicationWayHRxesViewModel
   */
  Dose: string;
  /**
   *日
   *
   * @type {string}
   * @memberof MedicationWayHRxesViewModel
   */
  Days: string;
}




@Injectable({
  providedIn: 'root'
})

export class HistApi {
  constructor(private webApiFactory: WebApiClient,
    private router: Router, private routeInfo: RouteInfoService,
    private connectionIdService: SignalRConnectionIdService) {
    this.api = this.webApiFactory.createHisService('Hist/hist');
    this.apiView = this.webApiFactory.createHisService('hist/histview');
    this.api.enableLoader = false;
  }

  api: WebApiService;
  apiView: WebApiService;
  EditOpt: HistEditOption;
  //#region Promise寫法
  getLabOutClinicReport(registerId: number, clinic: Clinic): Promise<RepeatedPrescriptionDto> {
    return this.api.post('GetLabOutClinicReport?registerId=' + registerId + '&isLabOutClinic=' + true, clinic).toPromise<RepeatedPrescriptionDto>();
  }
  getReceiptInfo(registerId: number): Promise<ReceiptInfoDto> {
    return this.api.get('GetReceiptInfo?registerId=' + registerId).toPromise<ReceiptInfoDto>();
  }

  getDrugBag(registerId: number, rxIds: number[], customBagRules?: any[]): Promise<DrugBagInfo> {
    const request = {
      registerId,
      rxIds,
      customBagRules: customBagRules || null
    };
    return this.api.post('GetDrugBag', request).toPromise<DrugBagInfo>();
  }
  getCMSDrugBag(registerId: number, rxIds: number[], hrxRules?: CmsHrxRule[], customBagRules?: any[]): Promise<DrugBagInfo> {
    const request: GetCMSDrugBagRequest = {
      registerId,
      rxIds,
      hrxRules,
      customBagRules
    };
    return this.api.post('GetCMSDrugBag', request).toPromise<DrugBagInfo>();
  }
  getRepeatedPrescription(registerId: number, sign: string, clinic: Clinic, userCid: string, userName: string, isUseQRcode: boolean = false, isCompressed: boolean = true): Promise<RepeatedPrescriptionDto> {
    return this.api.post('GetRepeatedPrescription?registerId=' + registerId + '&sign=' + sign + '&userCid=' + userCid + '&userName=' + userName + '&isUseQRcode=' + isUseQRcode + '&isCompressed=' + isCompressed, clinic).toPromise<RepeatedPrescriptionDto>();
  }

  getBy(histId: number[]): Promise<WholeHist[]> {
    return this.api.get('GetBy?histIds=' + histId.join(',')).toPromise<WholeHist[]>();
  }
  GetRegIdList(histId: number[]): Promise<number[]> {
    return this.api.get('GetRegIdList?histIds=' + histId.join(',')).toPromise<number[]>();
  }
  getWholeHist(param: GetWholeHistQuery): Promise<WholeHist> {
    return this.api.get('get', param).toPromise<WholeHist>();
  }
  enterRoom(regId: number, loadNext: boolean, patId: number = 0): Promise<EnterRoomDto> {
    return this.api.get('EnterRoom', { regId, loadNext, patId }).toPromise<EnterRoomDto>();
  }
  enterPharRoom(regId: number, loadNext: boolean, patId: number = 0): Promise<EnterRoomDto> {
    return this.api.get('EnterPharmacyRoom', { regId, loadNext, patId }).toPromise<EnterRoomDto>();
  }
  getFundingSourceRxes(): Promise<decreeRx[]> {
    return this.api.get('GetFundingSorucesRxes').toPromise<decreeRx[]>();
  }

  /**取得門診紀錄，補印時，取決是否勾選相關列印的資訊 例如：管制藥、是否有檢驗項目等資訊 */
  getPrintDrug(regId: number): Promise<HistPrintDrugDto> {
    return this.api.get('GetPrintDrug/' + regId).toPromise<HistPrintDrugDto>();
  }

  async getEditOptions(): Promise<HistEditOption> {
    if (!this.EditOpt) {
      this.EditOpt = await this.api.get('GetEditOptions').toPromise<HistEditOption>();
    }
    return this.EditOpt;
  }
  async GetDosages(): Promise<DosageDTO[]> {
    return await this.api.get('GetDosages').toPromise<DosageDTO[]>();
  }
  async GetExecutorList(): Promise<ValueTextPair[]> {
    if (this.EditOpt && this.EditOpt?.executor && this.EditOpt?.executor?.length > 0) {
      return this.EditOpt.executor;
    } else {
      return await this.api.get('GetExecutorList').toPromise<ValueTextPair[]>();
    }
  }
  async GetRxOptions(): Promise<RxOpt[]> {
    return await this.api.get('GetRxOptions').toPromise<RxOpt[]>();
  }
  async GetRsOptions(): Promise<RsOpt[]> {
    return await this.api.get('GetRsOptions').toPromise<RsOpt[]>();
  }
  async GetDxOptions(diagVersion: DxVersionTag = ''): Promise<DxOpt[]> {
    return await this.api.get('GetDxOptions?diagVersion=' + diagVersion).toPromise<DxOpt[]>();
  }
  async GetAllDxOptions(): Promise<DxOpt[]> {
    return await this.api.get('GetAllDxOptions').toPromise<DxOpt[]>();
  }
  async GetSPCOptions(): Promise<ValueTextPair[]> {
    return await this.api.get('GetSPCOptions').toPromise<ValueTextPair[]>();
  }
  async GetStatOptions(): Promise<StatOpts> {
    return await this.api.get('GetStatOptions').toPromise<StatOpts>();
  }
  async ParseStatFrom(date: Date): Promise<void> {
    return await this.api.get('ParseStatFrom?from=' + new Date(date).toLocaleDateString()).toPromise<void>();
  }
  async GetStatByDx(dx: string, tp: 'rx' | 'cc' | 'pe'): Promise<{ Self: string[], Clinic: string[] }> {
    return await this.api.get('GetStatByDx?dx=' + dx + '&tp=' + tp).toPromise<{ Self: string[], Clinic: string[] }>();
  }
  async SetSelfPay(regId: number) {
    return await this.api.post('SetSelfPay?regId=' + regId, null).toPromise();
  }
  async DeleteHist(regId: number, isphar: boolean = false): Promise<any> {
    var p = await this.api.delete('DeleteHist?regId=' + regId + '&isPhar=' + isphar, null).toPromise<any>();
    return p;
  }
  async RecoveryHist(regId: number): Promise<any> {
    return await this.api.put('RecoveryHist?regId=' + regId, null).toPromise<any>();
  }
  async GetProphylacticHealth(pId: number, date: Date | string): Promise<ValueTextPair[]> {
    var d = new Date(date).toLocaleDateString();
    return await this.api.get('GetProphylacticHealth?pId=' + pId + '&date=' + d, null).toPromise<ValueTextPair[]>();
  }

  async GetHomecareRxSetting(rxCode: string, paySysA: string): Promise<homecareRx[]> {
    var p = 'GetHomecareRxSetting?rxCode=' + rxCode;
    if (paySysA) p += '&paySysA=' + paySysA;
    return await this.api.get(p).toPromise<homecareRx[]>();
  }

  async GetHistArrearReceipt(regId: number): Promise<ArrearReceiptViewModel> {
    return await this.api.get(`GetHistArrearReceipt?regId=${regId}`).toPromise<ArrearReceiptViewModel>();
  }

  async GetCommonRxSetting(rxCode: string, paySysA: string, dateQuery: Date | string): Promise<homecareRx[]> {
    var p = 'GetCommonRxSetting?rxCode=' + rxCode + '&dateQuery=' + dateQuery;
    if (paySysA) p += '&paySysA=' + paySysA;
    return await this.api.get(p).toPromise<homecareRx[]>();
  }

  async GetHrxInit(query: HrxInitQuery): Promise<HrxInitResult[]> {
    return await this.api.post('GetHrxInit', query).toPromise<HrxInitResult[]>();
  }
  async GetNextRegId(regId: number) {
    return await this.api.get('GetNextRegId?rId=' + regId).toPromise<number>();
  }
  //#endregion
  // #region data service --------------------

  private queryAddCount(query: string, count?: number): string {
    if (count) {
      return query + '&count=' + count;
    } else {
      return query;
    }
  }

  getChiAskOptions(codeName?: string, count?: number) {
    let query = 'getChiAskOptions?name=' + codeName;
    query = this.queryAddCount(query, count);
    return this.api.get(query).toPromise<SystemCode[]>();
  }
  getChiLookOptions(codeName?: string, count?: number) {
    let query = 'getChiLookOptions?name=' + codeName;
    query = this.queryAddCount(query, count);
    return this.api.get(query).toPromise<SystemCode[]>();
  }
  getChiPulseOptions(codeName?: string, count?: number) {
    let query = 'getChiPulseOptions?name=' + codeName;
    query = this.queryAddCount(query, count);
    return this.api.get(query).toPromise<SystemCode[]>();
  }
  getChiBianZhengOptions(codeName?: string, count?: number) {
    let query = 'getChiBianZhengOptions?name=' + codeName;
    query = this.queryAddCount(query, count);
    return this.api.get(query).toPromise<SystemCode[]>();
  }
  getChiTreatRuleOptions(codeName?: string, count?: number) {
    let query = 'getChiTreatRuleOptions?name=' + codeName;
    query = this.queryAddCount(query, count);
    return this.api.get(query).toPromise<SystemCode[]>();
  }
  getChiTreatEffectOptions(codeName?: string, count?: number) {
    let query = 'getChiTreatEffectOptions?name=' + codeName;
    query = this.queryAddCount(query, count);
    return this.api.get(query).toPromise<SystemCode[]>();
  }
  getChiDoctorOrderOptions(codeName?: string, count?: number) {
    let query = 'getChiDoctorOrderOptions?name=' + codeName;
    query = this.queryAddCount(query, count);
    return this.api.get(query).toPromise<SystemCode[]>();
  }

  private dxCache = new Map();
  async getDiagByCode(code: string, diagVersion: string = ''): Promise<Dx> {
    //cache key原本是code，但因為有可能同一個code有不同版本的診斷，所以加上版本號
    // var key = code;
    var key = code + ';' + diagVersion;
    var cache = this.getDiagFromCache(key);
    if (cache) {
      return cache;
    }
    var dx = await this.api.get('GetDiagByCode?code=' + code + '&diagVersion=' + diagVersion).toPromise<Dx>();
    this.dxCache.set(key, dx);
    return dx;
  }
  /** 診間輸入檢查專用：驗代碼是否存在於該版 SDx/SPHc(擋假碼)；不快取 */
  async getDiagByCodeForCheck(code: string, diagVersion: string = ''): Promise<Dx> {
    return await this.api.get('GetDiagByCodeForCheck?code=' + code + '&diagVersion=' + diagVersion).toPromise<Dx>();
  }
  async getDiagWithICD9ByCode(code: string, diagVersion: string = ''): Promise<DxWithICD9> {
    // var key = code;
    var key = code + ';' + diagVersion;
    var dx = await this.api.get('getDiagWithICD9ByCode?code=' + code + '&diagVersion=' + diagVersion).toPromise<DxWithICD9>();
    this.dxCache.set(key, dx);
    return dx;
  }
  getDiagByApplyCode(code: string): Promise<Dx> {
    //傳入的code是預防保健，或N186，Z23，新舊版本(2014/2023)都有，所以不用判斷版本
    return this.api.get('GetDiagByApplyCode?code=' + code).toPromise<Dx>();
  }
  private getDiagFromCache(code: string) {
    if (this.dxCache.has(code)) {
      return this.dxCache.get(code);
    }
    return null;
  }
  private convertToString(intArray: number[]) {
    let str = '';
    if (!intArray) { return 'UnknownType'; }
    intArray.forEach(x => {
      str += x + ',';
    });
    str = str.substring(0, str.length - 1); // 移除最後逗號
    return str;
  }

  async getOrderByCode(code: string, typeArray: number[]): Promise<Rx> {
    const types = this.convertToString(typeArray);
    return await this.api.get('GetOrderByCode?code=' + code + '&types=' + types).toPromise();
  }
  async getTCMFormulaByCode(code: string): Promise<TCMFormula> {
    return await this.api.get('getTCMFormulaByCode?code=' + code).toPromise();
  }
  GetOrderByStdCodeAsync(code: string): Promise<Rx> {
    return this.api.get('GetOrderByStdCodeAsync?code=' + code).toPromise();
  }
  getOrdersOfOrderSet(drugId: number): Promise<Rx[]> {
    return this.api.get('GetOrdersOfOrderSet?drugId=' + drugId).toPromise();
  }

  // #endregion data service

  // #region reg service --------------------
  async updateRegStatusByAction(regId: number, action: HistActionEnum, origRegStatusCode: string) {
    await this.api.get('UpdateRegStatusByAction?id=' + regId + '&action=' + action + '&origRegStatusCode=' + origRegStatusCode)
      .toPromise();
  }
  // #endregion reg service

  // #region NHI service
  async GetDDIData(data: nhiReq): Promise<ddiData> {
    return await this.api.post('GetDDIData', data).toPromise<ddiData>();
  }

  async GetAllergyData(data: nhiReq): Promise<ddiData> {
    return await this.api.post('GetAllergyData', data).toPromise<ddiData>();
  }

  async GetMedPrtData(data: nhiReq): Promise<medPrtData> {
    return await this.api.post('GetMedPrtData', data).toPromise<medPrtData>();
  }
  // #region NHI service

  // #region save --------------------
  private getSaveData(submitData: WholeHist): WholeHist {
    return Object.assign({}, submitData, { ConnectionId: this.connectionIdService.connectionId });
  }

  async save(submitData: WholeHist): Promise<HistToICCardData> {
    var loaderEnabled = this.api.enableLoader;
    this.api.enableLoader = false;
    var ret = await this.api.put('save', this.getSaveData(submitData)).toPromise<HistToICCardData>();
    this.api.enableLoader = loaderEnabled;
    return ret;
  }
  async savePhar(submitData: WholeLargeHist): Promise<HistToICCardData> {
    var loaderEnabled = this.api.enableLoader;
    this.api.enableLoader = false;
    var ret = await this.api.put('SavePhar', submitData).toPromise<HistToICCardData>();
    this.api.enableLoader = loaderEnabled;
    return ret;
  }
  async HistCheck(submitData: WholeHist): Promise<HistCheckResult[]> {
    var loaderEnabled = this.api.enableLoader;
    this.api.enableLoader = false;
    var ret = await this.api.post('HistCheck', submitData).toPromise<HistCheckResult[]>();
    this.api.enableLoader = loaderEnabled;
    return ret;
  }
  /** 更新主訴 */
  async saveCC(histId: number, cc: string, submitData: WholeHist): Promise<any> {
    var loaderEnabled = this.api.enableLoader;
    this.api.enableLoader = false;
    var ret = await this.api.put('SaveCC?histId=' + histId + '&cc=' + cc, this.getSaveData(submitData)).toPromise<HistToICCardData>();
    this.api.enableLoader = loaderEnabled;
    return ret;
  }

  async SaveReferralIC(ic: NHIRegIC) {
    var loaderEnabled = this.api.enableLoader;
    this.api.enableLoader = false;
    var ret = await this.api.put('SaveReferralIC', ic).toPromise<CustomResult>();
    return ret;
  }

  // #endregion save

  // #region payment --------------------
  calculatePayment(submitData: WholeHist): Promise<PaymentMaster> {
    return this.api.put('calculatePayment', submitData).toPromise<PaymentMaster>();
  }
  // #endregion payment

  // #region route service --------------------

  // #endregion route service

  async getVitalSign(pId: number, pSize: number, pSkip: number): Promise<PageData2<VitalSign>> {
    return await this.api.get('GetVitalSign', {
      pId: pId,
      pageSize: pSize,
      pageSkip: pSkip
    }).toPromise<PageData2<VitalSign>>()
  }
  async GetSPCTreat(data: any): Promise<string> {
    return await this.api.post('GetSPCTreat', data).toPromise<string>();
  }

  // async UpdatelackCardRegic(data: LackNegic): Promise<void> {
  //   return await this.api.post('UpdatelackCardRegic', data).toPromise<void>();
  // }
  async SaveNHIRecord(data: NhiRecord): Promise<void> {
    // debugger
    var id = await this.api.post('SaveNHIRecord', data).toPromise<number>();
    data.Id = id;
  }
  async GetNHIRecord(patientId: number): Promise<NhiRecord> {
    return await this.api.get('GetNHIRecord?patId=' + patientId).toPromise<NhiRecord>();
  }
  async GetReCardList(PatientCId: string, parentPId: number): Promise<RecardListDto[]> {
    return await this.api.get('GetReCardList?PatientCId=' + PatientCId + '&parentPId=' + parentPId).toPromise<RecardListDto[]>();
  }
  async CheckHomeCareUrgent(data: HistOrder[], urgentHC: string): Promise<string> {
    return await this.api.post('CheckHomeCareUrgent?urgentHC=' + urgentHC, data).toPromise<string>();
  }

  async saveMulti(wholeHistData: WholeLargeHist): Promise<HistToICCardData> {
    var loaderEnabled = this.api.enableLoader;
    this.api.enableLoader = false;

    var ret = await this.api.put('saveMulti', wholeHistData).toPromise<HistToICCardData>();
    this.api.enableLoader = loaderEnabled;
    return ret
  }
  async saveIgsn(data: PrescriptionSave[]) {
    var ret = await this.api.put('SaveIgsn', data).toPromise();
    // this.api.enableLoader = loaderEnabled;
    return ret
  }

  async checkIgsn(data: PrescriptionSave[]) {
    var ret = await this.api.post('CheckIgsn', data).toPromise<PrescriptionFeedBack>();
    // this.api.enableLoader = loaderEnabled;
    return ret
  }
  async savedxFromSdx(data: string[]) {

    var ret = await this.api.put('SavedxFromSdx', data).toPromise();
    return ret
  }

  async CallTeleMed(regId: number): Promise<RoomConnectionDTO> {
    var ret = await this.api.get('CallTeleMed?regId=' + regId).toPromise<RoomConnectionDTO>();
    return ret;
  }
  async ReviewTeleMed(regId: number): Promise<RoomConnectionDTO> {
    var ret = await this.api.get('ReviewTeleMed?regId=' + regId).toPromise<RoomConnectionDTO>();
    return ret;
  }

  async GetRepeatedPrescriptSignAndData(sign: string, data: string, doctorICSqno: string, aesKey: string, compressed: boolean): Promise<RepeatedPrescriptionQRcode> {
    let request = new RepeatedPrescriptionRequest();
    request.Sign = sign || '';
    request.Data = data || '';
    request.DoctorICSqno = doctorICSqno || '';
    request.AesKey = aesKey;
    request.Compressed = compressed;
    var ret = await this.api.post('GetRepeatedPrescriptSignAndData', request).toPromise<RepeatedPrescriptionQRcode>();
    return ret;
  }

  async CreateERxData(url: string, sign: string, data: string, aesKey: string): Promise<any> {
    let request = new ERxDataRequest();
    request.Url = url || '';
    request.Sign = sign || '';
    request.Data = data || '';
    request.AesKey = aesKey || '';
    var ret = await this.api.post('CreateERxData', request).toPromise<any>();
    return ret;
  }


  async CheckLastPrescribeDate(data: CheckPrescribeDto): Promise<string> {
    return await this.api.post('CheckLastPrescribeDate', data).toPromise<string>();
  }

  async CheckMonthMaxPrescribeQty(data: CheckPrescribeDto): Promise<number> {
    return await this.api.post('CheckMonthMaxPrescribeQty', data).toPromise<number>();
  }

  async GenerateMedicationWayReport(regId: number): Promise<MedicationWayReportViewModel> {
    return await this.api.get(`GenerateMedicationWayReport?regId=${regId}`).toPromise<MedicationWayReportViewModel>();
  }
  async GetICWrite(patientCId: string, regDate: Date): Promise<HistToICCardData[]> {
    return await this.api.get('GetICWrite', { patientCId, regDate: regDate.toLocaleDateString() }).toPromise<HistToICCardData[]>();
  }
  async UpdateICWriteTime(regId: number): Promise<boolean> {
    return await this.api.post('UpdateICWriteTime?regId=' + regId, {}).toPromise<boolean>();
  }

  async GetVisitcountReport(data: VisitcountQueryDto, isShowLoader: boolean = true): Promise<VisitcountReportData[]> {
    const originalEnableLoader = this.api.enableLoader;
    // 臨時啟用載入指示器
    if (isShowLoader) {
      this.api.enableLoader = true;
    }
    try {
      // 執行請求
      return await this.api.post('GetVisitcountReport', data, isShowLoader).toPromise<VisitcountReportData[]>();
    } finally {
      // 恢復原始的 enableLoader 設定
      this.api.enableLoader = originalEnableLoader;
    }
  }

  async GetVisitcountList(data: VisitcountQueryDto, isShowLoader: boolean = true): Promise<VisitcountListData[]> {
    const originalEnableLoader = this.api.enableLoader;
    // 臨時啟用載入指示器
    if (isShowLoader) {
      this.api.enableLoader = true;
    }
    try {
      // 執行請求
      return await this.api.post('GetVisitcountList', data, isShowLoader).toPromise<VisitcountListData[]>();
    } finally {
      // 恢復原始的 enableLoader 設定
      this.api.enableLoader = originalEnableLoader;
    }
  }

  async GetVisitcountSum(data: VisitcountQueryDto, isShowLoader: boolean = true): Promise<VisitcountSumData[]> {
    const originalEnableLoader = this.api.enableLoader;
    // 臨時啟用載入指示器
    if (isShowLoader) {
      this.api.enableLoader = true;
    }
    try {
      // 執行請求
      return await this.api.post('GetVisitcountSum', data, isShowLoader).toPromise<VisitcountSumData[]>();
    } finally {
      // 恢復原始的 enableLoader 設定
      this.api.enableLoader = originalEnableLoader;
    }
  }

  async GenerateLabHrxListReport(data: LabPrescriptionAndHrxListQuery): Promise<LabHRxListPageCollection> {
    return await this.api.post('GenerateLabHrxListReport', data).toPromise<LabHRxListPageCollection>();
  }

  async GenerateLabPrescriptionReport(data: LabPrescriptionAndHrxListQuery): Promise<LabPrescriptionPageCollection> {
    return await this.api.post('GenerateLabPrescriptionReport', data).toPromise<LabPrescriptionPageCollection>();
  }

  async GetICDEncode(data: TreatmentData): Promise<TreatmentData> {
    return await this.api.post('GetICDEncode', data).toPromise<TreatmentData>();
  }

  async GetICDDecode(data: TreatmentData): Promise<TreatmentData> {
    return await this.api.post('GetICDDecode', data).toPromise<TreatmentData>();
  }
  async GetJailHist(sDate: Date, eDate: Date, doctorId: number, pSize: number, pSkip: number): Promise<PageData2<JailHistDto>> {
    return await this.api.get('GetJailHist',
      {
        StartDate: DateHelper.getFormatedDateString(sDate, false, '-', false),
        EndDate: DateHelper.getFormatedDateString(eDate, false, '-', false),
        DoctorId: doctorId,
        pageSize: pSize,
        pageSkip: pSkip
      }).toPromise<PageData2<JailHistDto>>()
  }

  async GetHistViewList(patientId: number): Promise<HistListItem[]> {
    return await this.apiView.get('getAll/' + patientId).toPromise<HistListItem[]>()
  }
  async GetHistExtendViewList(query): Promise<PageData2<HistView>> {
    return await this.apiView.post('GetExtendViewList', query).toPromise<PageData2<HistView>>()
  }
  /** 取得日核對表統計報表 (依就診日期)  */
  async GenerateDailyReconReport(query: DailyReconReportQueryDto, isShowLoader: boolean = true): Promise<DailyReconReportDto[]> {
    const originalEnableLoader = this.api.enableLoader;
    if (isShowLoader) {
      this.api.enableLoader = true;
    }
    try {
      return await this.api.post('GetDailyReconReport', query).toPromise<DailyReconReportDto[]>();
    } finally {
      this.api.enableLoader = originalEnableLoader;
    }
  }

  /** 取得日核對表統計報表 (依欠卡)  */
  async GenerateDailyReconReportLack(query: DailyReconReportQueryDto, isShowLoader: boolean = true): Promise<DailyReconReportLackDto[]> {
    const originalEnableLoader = this.api.enableLoader;
    if (isShowLoader) {
      this.api.enableLoader = true;
    }
    try {
      return await this.api.post('GetDailyReconLackReport', query).toPromise<DailyReconReportLackDto[]>();
    } finally {
      this.api.enableLoader = originalEnableLoader;
    }
  }

  /** 取得醫療費用收據(簽約用)  */
  // async GetFeeSigningReceipt(query: FeeSigningReceiptQueryDto, isShowLoader: boolean = true): Promise<FeeSigningReceiptDto[]> {
  async GetFeeSigningReceipt(registerId: number, isShowLoader: boolean = true): Promise<ReceiptInfoDto> {
    const originalEnableLoader = this.api.enableLoader;
    if (isShowLoader) {
      this.api.enableLoader = true;
    }
    try {
      // return await this.api.post('GetFeeSigningReceipt', query).toPromise<FeeSigningReceiptDto[]>();
      return this.api.get('GetReceiptInfo?registerId=' + registerId).toPromise<ReceiptInfoDto>();
    } finally {
      this.api.enableLoader = originalEnableLoader;
    }
  }

  /** 醫令執行人員暨明細報表  */
  async GetHistUserReport(query: HistUserReportQueryDto, isShowLoader: boolean = true): Promise<HistUserReportData[]> {
    const originalEnableLoader = this.api.enableLoader;
    if (isShowLoader) {
      this.api.enableLoader = true;
    }
    try {
      return await this.api.post('HistUserReport/GetList', query).toPromise<HistUserReportData[]>();
    } finally {
      this.api.enableLoader = originalEnableLoader;
    }
  }
  async saveBlueTooth(data: OrderMedical): Promise<HistToICCardData> {
    var loaderEnabled = this.api.enableLoader;
    this.api.enableLoader = false;

    var ret = await this.api.put('SaveBlueTooth', data).toPromise<HistToICCardData>();
    this.api.enableLoader = loaderEnabled;
    return ret
  }

}

export class RoomConnectionDTO {
  IsClosed: boolean;
  DoctorUrl: string;
  PatientUrl: string;

}

export class CheckPrescribeDto {
  Id: number;
  ClinicId: number;
  PatientId: number;
  RxCode: string;
  RegDate: Date;
  IntervalDays: number;
}
export class JailHistDto {
  /** 健保卡號 */
  CardNo: string;
  /** 身分證 */
  CId: string;
  /** 生日 */
  Birth: string;
  /** 生日 */
  PatientBirth: string;
  /** 醫療機構代碼 */
  HospCode: string;
  /** 看診時間 */
  RegDate: string;
  /** 主診斷 */
  Dx: string;
  /** 掛號費 */
  RegFee: number;
  /** 門診部分負擔 */
  OPDPart: number;
  /** 住院部分負擔 */
  InHospPart: number;
  /** 特才費 */
  Mat: number;
  /** 自費 */
  Own: number;
  /** 藥品部分負擔 */
  RxPart: number;
}

export interface DosageDTO {
  Name: string;
  Code: string;
  ApplyCode: string;
  TMDay: number;
  TMQty: number;
  UsageTime: string;
  UsageTimeLTC: string;
  Id: number;
}
export interface EnterRoomDto {
  hist: WholeHist;
  hasUploaded: boolean;
  nextPatients: IRegNextPatientDto[];
  firstSametreatDate: Date;
  referals: Referral[];
  histViewList: HistListItem[];
  allPhar: EnterRoomPharsCountDto;
}

export interface GetCMSDrugBagRequest {
  registerId: number;
  rxIds: number[];
  hrxRules?: CmsHrxRule[];
  customBagRules?: any[];
}

export interface CmsHrxRule {
  field: string;    // 欄位名稱，如 "RxCode"
  rule: string;     // 規則類型 "in" 或 "notin"
  values: string;   // 規則值，逗號分隔 "R001,R002,R003"
}
export class EnterRoomPharsCountDto {
  constructor(init?: Partial<EnterRoomPharsCountDto>) {
    this.PharIDCount = {};
    this.IsMountain = false;
    this.Ovr_dsc = 80;
    this.Ovr_xxx = 100;

    if (init) {
      Object.assign(this, init);

      // 如果從後端來的是物件（正常 C# Dictionary），直接指派即可
      if (init.PharIDCount) {
        this.PharIDCount = { ...init.PharIDCount };
      }
    }
  }

  /** 標記 */
  PharIDCount: { [key: number]: number };

  /** 是否為山地離 */
  IsMountain: boolean;

  /** 藥事合理量第一段 */
  Ovr_dsc: number;

  /** 藥事合理量第二段 */
  Ovr_xxx: number;
}
